import React from 'react';
import {FormattedMessage} from 'react-intl';
import OrderInspectionForm from '../../../_common/components/OrderInspectionForm';
import Spinner from '../../../_common/components/Spinner';
import Grid from '../../../_common/components/GridTasksNotes';
import ButtonAction from '../../../_common/components/ButtonAction';
import {useInspectionDetailsUIContext} from '../InspectionsDetailsUIContext';

const InspectionDetails = () => {
  const {
    formik,
    users,
    loadingData,
    validate,
    decisionTreeProps,
    handleEditInspection,
    fieldNames
  } = useInspectionDetailsUIContext();
  const selectProps = {users};
  const {values, setFieldValue, dirty, handleChange} = formik;
  const isValid = Object.keys(validate(values)).length === 0;

  return (
    <>
      {loadingData
        ? <Spinner
          customContainerStyles={'w-100 h-100 d-flex justify-content-center align-items-center'}/>
        : (
          <div className={'w-100 px-8 my-8 mx-auto'}>
            <OrderInspectionForm
              values={values}
              decisionTreeProps={decisionTreeProps}
              selectProps={selectProps}
              fieldNames={fieldNames}
              setFieldValue={setFieldValue}
              disabledFormCondition={!values.shumaID}
              handleChange={handleChange}
              tasksSection={(
                <>
                  <ButtonAction
                    label={<FormattedMessage
                      id={'inspection-details-button-label-edit'}
                      defaultMessage={'Edit inspection'}
                    />}
                    useIcon={'/media/common/Check-in-circle_white.svg'}
                    customClassnames={'d-block mx-auto'}
                    onClick={() => handleEditInspection(values)}
                    disabled={!(isValid && dirty)}
                  />
                  <Grid/>
                </>
              )}
            />
          </div>
        )}
    </>
  );
};

export default InspectionDetails;
